var map = {
	"./bed-01.svg": [
		134,
		3
	],
	"./bed-05.svg": [
		135,
		4
	],
	"./cabinet-01.svg": [
		136,
		5
	],
	"./chair-02.svg": [
		137,
		6
	],
	"./chair-06.svg": [
		138,
		7
	],
	"./closet-01.svg": [
		139,
		8
	],
	"./closet-02.svg": [
		140,
		9
	],
	"./couch-01.svg": [
		141,
		10
	],
	"./desk-02.svg": [
		142,
		11
	],
	"./lamp-01.svg": [
		143,
		12
	],
	"./plant-01.svg": [
		144,
		13
	],
	"./room.svg": [
		145,
		14
	],
	"./shelf-03.svg": [
		146,
		15
	],
	"./table-06.svg": [
		147,
		16
	],
	"./table-08.svg": [
		148,
		17
	],
	"./tv-01.svg": [
		149,
		18
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 128;
module.exports = webpackAsyncContext;